export default __webpack_public_path__ + "static/media/hacker-using-laptop.51a81ae7.gif";